export const stats = [
  { value: '+52', label: 'Sessions Ready-to-Teach' },
  { value: '+2,000', label: 'Instructors Satisfied' },
  { value: '4,500+', label: 'Planning Hours Saved' },
  { value: '99%', label: 'Would Recommend It' },
]

export const differenceStats = [
  { value: '+52', label: 'Complete Curriculum (Mat to Reformer)' },
  { value: '6', label: 'Specialized Digital Volumes' },
  { value: '100%', label: 'Instantly Downloadable PDF' },
]

export const beforeItems = [
  'Hours spent "researching" exercises on Instagram',
  'Repetitive sequences that make clients lose interest',
  'No clear progression from Beginner to Athletic',
  'Insecurity teaching prenatal or injury recovery',
  "Low retention because clients can't see a long-term plan",
]

export const afterItems = [
  "5-minute review and you're ready to teach",
  'Visual movement maps that explain the "why"',
  'Athletic and clinical protocols in your repertoire',
  'Professional trackers that prove real transformation',
  'Premium prices justified by a systematic approach',
]

export const recognizeItems = [
  {
    icon: 'time' as const,
    text: 'Spending your entire Sunday planning what should take minutes',
  },
  {
    icon: 'cue' as const,
    text: 'Arriving at the studio unsure how to cue a complex Reformer move',
  },
  {
    icon: 'repeat' as const,
    text: 'Feeling stuck teaching the same 10 exercises every single week',
  },
  {
    icon: 'search' as const,
    text: 'Struggling to find high-quality visual fiches to show your clients',
  },
  {
    icon: 'caution' as const,
    text: 'Feeling unsure when a prenatal client or someone with back pain walks in',
  },
  {
    icon: 'moon' as const,
    text: 'Still not ready for Monday morning by Sunday night',
  },
]

export const packItems = [
  {
    icon: 'mastery' as const,
    title: 'Volumes 1–4: The Mastery Series',
    text: 'Matwork Foundations, Reformer Mastery, Athletic Performance, and Prop Magic (ball, ring, band, roller)',
  },
  {
    icon: 'clinical' as const,
    title: 'Volume 5: Special Populations',
    text: 'Your expert guide to the most profitable niches: prenatal, postpartum, seniors, and injury recovery',
  },
  {
    icon: 'flows' as const,
    title: 'Volume 6: Group Class Flows',
    text: '52 complete class flows with music BPM integration and energy management',
  },
  {
    icon: 'cueing' as const,
    title: 'Elite Cueing Scripts',
    text: 'Prompts that tell you exactly what to say to correct form and inspire movement in seconds',
  },
  {
    icon: 'anatomy' as const,
    title: 'Visual Anatomy Maps',
    text: 'High-quality graphics that make biomechanics simple for clients to understand and trust',
  },
  {
    icon: 'tracker' as const,
    title: 'Transformation Trackers',
    text: 'Printable sheets for mobility, strength, and progress that turn students into loyal members',
  },
]

export const insidePages = [
  {
    volume: 'Volume 1 · Matwork Foundations',
    title: 'Exercise fiches your clients can actually read',
    text: 'Every movement broken into phases, with cues, muscle activation maps, safety notes, and the exact prescription.',
    image:
      'https://cdn.magicpatterns.com/uploads/j8GpG3ia7UMRypLdhcKaYa/Captura-de-pantalla-2026-09-19-a-las-2.06.20_p._m..webp',
  },
  {
    volume: 'Volume 2 · Reformer Mastery',
    title: 'The 6 body positions, mapped for flow',
    text: 'Sequence your class by position instead of guessing — fewer transitions, more momentum, zero dead air.',
    image:
      'https://cdn.magicpatterns.com/uploads/n3zDTHAGaxhaJFtspdY2oS/Captura-de-pantalla-2026-09-19-a-las-2.08.06_p._m..webp',
  },
  {
    volume: 'Volume 3 · Athletic Performance',
    title: 'Elite progressions with word-for-word cues',
    text: 'Advanced repertoire explained so precisely you can teach Jackknife or Rollover with total authority.',
    image:
      'https://cdn.magicpatterns.com/uploads/1n6PxQ4HyePAPS3MGTan1t/Captura-de-pantalla-2026-09-19-a-las-2.08.59_p._m..webp',
  },
  {
    volume: 'Volume 4 · Prop Magic',
    title: 'Phase-by-phase prop work with breath timing',
    text: 'Ring, ball, band and roller sequences timed to the breath, so intensity builds exactly where you want it.',
    image:
      'https://cdn.magicpatterns.com/uploads/mVPTygskYtvWPZg8nxS6Fa/Captura-de-pantalla-2026-09-19-a-las-2.09.49_p._m..webp',
  },
  {
    volume: 'Volume 5 · Special Populations',
    title: 'Modification cards for prenatal and recovery',
    text: 'Standard vs. modified, the cue to say out loud, and the reason behind it — never freeze in front of a client again.',
    image:
      'https://cdn.magicpatterns.com/uploads/5PkGSiV6Y87CGeTpPLbatt/Captura-de-pantalla-2026-09-19-a-las-2.11.07_p._m..webp',
  },
]

export const bonuses = [
  {
    title: 'The 5-Minute Class Planner™',
    text: 'Your implementation accelerator — a full session mapped before your coffee cools',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/b16e10d0-8391-4277-aa67-c870e0430399.jpg',
  },
  {
    title: 'The Client Retention Scriptbook™',
    text: 'The conversations that keep clients booking with you for years, not weeks',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/7286207d-fab3-4c73-b333-1b5c6bd8e977.jpg',
  },
  {
    title: 'The Premium Package Builder™',
    text: 'How to structure and price result-based packages at $1,200+',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/381c1974-1a52-4166-aa75-65bc070f0b1d.jpg',
  },
  {
    title: 'The Studio Experience Checklist™',
    text: 'Boutique-level excellence, from the first hello to the final stretch',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/596420ee-6158-4513-822e-0a5611749d2e.jpg',
  },
  {
    title: 'The Pilates Content & Referral Kit™',
    text: 'A social media and word-of-mouth engine built for instructors',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/c7f857fa-5002-45a8-8b79-71900ebf8584.jpg',
  },
]

export const offerRows = [
  { label: 'PILATES READY™ Pack (6 Digital Volumes)', value: '$77' },
  { label: '5 Exclusive Strategic Bonuses', value: '$148' },
]

export const testimonials = [
  {
    quote:
      'I finally have my weekends back. The progression from Foundations to Athletic Pilates is exactly what I needed for my diverse clients.',
    name: 'Sarah M.',
    role: 'Reformer Instructor',
  },
  {
    quote:
      "The visual fiches are a game-changer. My clients finally 'get' the movement, and my classes feel 10x more premium.",
    name: 'Ella B.',
    role: 'Studio Owner',
  },
  {
    quote:
      'The Package Builder bonus alone helped me double my rates this month. Worth every penny.',
    name: 'Maya K.',
    role: 'Clinical Pilates Specialist',
  },
]

export const faqs = [
  {
    q: 'How do I receive the material?',
    a: 'Instantly. After payment you get an email with your download link and immediate PDF access to every volume.',
  },
  {
    q: 'Is this for Mat or Reformer?',
    a: 'Both. The system covers the full Pilates spectrum — matwork, reformer, props, and athletic progressions.',
  },
  {
    q: "Does this work if I'm a new instructor?",
    a: "Yes. It's designed to be your mentor in a box: the cueing scripts tell you exactly what to say from your very first class.",
  },
  {
    q: 'Is there a physical version?',
    a: "It's digital so you get instant access, but every page is designed to be printed at studio quality.",
  },
]
